import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import s from './Header.style';

/* eslint-disable */
class Header extends Component {
  state = {
    isMobileNavActive: false,
  };

  componentDidMount() {
    this.mobileNavTrigger = React.createRef();
  }

  toggleMobileNav() {
    this.setState({
      ...this.state,
      isMobileNavActive: !this.state.isMobileNavActive,
    });
  }

  hideMobileNav() {
    this.setState({
      ...this.state,
      isMobileNavActive: false,
    });
  }

  render() {
    return (
      <header className={css([s.header, this.state.isMobileNavActive ? s.headerActive : ''])}>
        <button
          type="button"
          onClick={this.toggleMobileNav.bind(this)}
          className={css(s.header__mobilenav)}
          ref={this.mobileNavTrigger}
          aria-label="Mobil menü megnyitása"
          aria-expanded={this.state.isMobileNavActive}
        >
          Mobil menü
        </button>
        <nav className={css([s.header__nav, this.state.isMobileNavActive ? s.headerNavActive : ''])}>
          <NavLink
            onClick={this.hideMobileNav.bind(this)}
            className={({ isActive }) => css(s.header__link) + (isActive ? ' ' + css(s.header__active_link) : '')}
            end
            to="/"
            aria-label="Nyitólap"
          >
            <div className={css(s.logoWrapper)}>
              <Icon name="home" className={css(s.logo)} />
            </div>
            <span>Nyitólap</span>
          </NavLink>
          <NavLink
            onClick={this.hideMobileNav.bind(this)}
            className={({ isActive }) => css(s.header__link) + (isActive ? ' ' + css(s.header__active_link) : '')}
            end
            to="/rolam"
          >
            Rólam
          </NavLink>
          <NavLink
            onClick={this.hideMobileNav.bind(this)}
            className={({ isActive }) => css(s.header__link) + (isActive ? ' ' + css(s.header__active_link) : '')}
            end
            to="/szolgaltatasok"
          >
            Szolgáltatásaim
          </NavLink>
          <NavLink
            onClick={this.hideMobileNav.bind(this)}
            className={({ isActive }) => css(s.header__link) + (isActive ? ' ' + css(s.header__active_link) : '')}
            to="/blog"
          >
            Blog
          </NavLink>
          <NavLink
            onClick={this.hideMobileNav.bind(this)}
            className={({ isActive }) => css(s.header__link) + (isActive ? ' ' + css(s.header__active_link) : '')}
            end
            to="/munkak"
          >
            Munkák
          </NavLink>
          <NavLink
            onClick={this.hideMobileNav.bind(this)}
            className={({ isActive }) => css(s.header__link) + (isActive ? ' ' + css(s.header__active_link) : '')}
            end
            to="/kontakt"
          >
            Kontakt
          </NavLink>
        </nav>
      </header>
    );
  }
}

export default Header;
